import React from 'react';

function SkillsList({ skill, index }) {
    return (
        <div className="skill-column">
            <span className="skill-number" aria-hidden="true">0{index + 1}</span>
            <h3>{skill.title}</h3>
            <ul>{skill.list.map(item => <li key={item}>{item}</li>)}</ul>
        </div>
    );
}

export default SkillsList;
